import React from "react";
import { Outlet } from "react-router";

import styled from "@emotion/styled";

const Container = styled.div`
    height: calc(100vh - 150px);
    overflow-y: auto;

    @media screen and (max-width: 767px) {
        height: calc(100vh - 155px);
    }

    /* Header logo is absolutely positioned and overflows below the header's bottom edge;
       nudge the "Back to ..." bar right so the logo does not cover it on the mentor flow. */
    > div:first-of-type > div:first-of-type {
        padding-left: 100px;
    }
`;

export const MentorLayout: React.FC = () => {
    return (
        <Container>
            <Outlet />
        </Container>
    );
};
